import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

export default function AccountRefreshNotice({ onClose, onLogin }) {
  const { t } = useTranslation();
  const dialogRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    const dialog = dialogRef.current;
    const buttons = dialog.querySelectorAll('button');
    buttons[0].focus();
    const keepFocus = event => {
      if (!dialog.contains(event.target)) buttons[0].focus();
    };
    const handleKey = event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onClose();
      }
      if (event.key === 'Tab') {
        event.preventDefault();
        const next = document.activeElement === buttons[0] ? buttons[1] : buttons[0];
        next.focus();
      }
    };
    document.addEventListener('keydown', handleKey);
    document.addEventListener('focusin', keepFocus);
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.removeEventListener('focusin', keepFocus);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [onClose]);

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4">
      <div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="account-refresh-title"
        aria-describedby="account-refresh-description" className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <h2 id="account-refresh-title" className="text-lg font-semibold text-ink-900">{t('orderAuth.noticeTitle')}</h2>
        <p id="account-refresh-description" className="mt-3 text-ink-600">{t('orderAuth.noticeMessage')}</p>
        <div className="mt-6 flex justify-end gap-3">
          <button type="button" onClick={onClose} className="rounded-lg border border-ink-200 px-4 py-2">{t('orderAuth.later')}</button>
          <button type="button" onClick={onLogin} className="rounded-lg bg-accent-500 px-4 py-2 text-white">{t('orderAuth.login')}</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
